import { jsxs as M, jsx as o } from "react/jsx-runtime";
import { useState as s, useEffect as F } from "react";
import { SingleSelectInput as D } from "./selectInput.js";
import { u as i, a } from "./index-6a632112.mjs";
import { Tooltip as O } from "./tooltip.js";
import { PopupTip as U } from "./popupTip.js";
import { c as n } from "./index-98c703e1.mjs";
import { S as j } from "./checkmarkFilled-c2b01ef1.mjs";
import { S as k } from "./types-b577bf77.mjs";
import { S as V } from "./informationFilled-05d57719.mjs";
import { Button as Z } from "./button.js";
function q({
  title: e,
  titleId: p,
  size: l,
  height: u,
  width: c,
  ...b
}) {
  const m = l ? k[l] : k.s;
  return /* @__PURE__ */ M(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      height: l ? m : u || m,
      width: l ? m : c || m,
      "aria-labelledby": p,
      ...b,
      children: [
        e ? /* @__PURE__ */ o("title", { id: p, children: e }) : null,
        /* @__PURE__ */ o("g", { clipPath: "url(#Decrease__Filled_svg__a)", children: /* @__PURE__ */ o(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M36 1.5c19.054 0 34.5 15.446 34.5 34.5 0 19.054-15.446 34.5-34.5 34.5C16.946 70.5 1.5 55.054 1.5 36 1.5 16.946 16.946 1.5 36 1.5Zm17.25 29.866h-34.5v8.625h34.5v-8.625Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ o("defs", { children: /* @__PURE__ */ o("clipPath", { id: "Decrease__Filled_svg__a", children: /* @__PURE__ */ o("path", { fill: "currentColor", d: "M0 0h72v72H0z" }) }) })
      ]
    }
  );
}
const G = i.div`
  &.Checked-wrapper {
    ${({
  theme: {
    components: { marketingComparisonTable: e }
  }
}) => a(e.CheckedWrapper)};
  }
`, J = i.div`
  &.Unchecked-wrapper {
    ${({
  theme: {
    components: { marketingComparisonTable: e }
  }
}) => a(e.UncheckedWrapper)};
  }
`, f = i.div`
  &.Information-wrapper {
    ${({
  theme: {
    components: { marketingComparisonTable: e }
  }
}) => a(e.InformationWrapper)};
  }
`, K = i.span`
  &.Text-wrapper {
    ${({
  theme: {
    components: { marketingComparisonTable: e }
  }
}) => a(e.TextWrapper)};
  }
`, L = ({
  type: e,
  informationTooltipProp: p,
  informationPopuptipProp: l,
  textValue: u,
  contentAlignment: c
}) => e === "checked" && /* @__PURE__ */ o(G, { className: n(["Checked-wrapper"]), children: /* @__PURE__ */ o(j, { size: "xs" }) }) || e === "unchecked" && /* @__PURE__ */ o(J, { className: n(["Unchecked-wrapper"]), children: /* @__PURE__ */ o(q, { size: "xs" }) }) || e === "information-popuptip" && l && /* @__PURE__ */ o(f, { className: n(["Information-wrapper"]), children: /* @__PURE__ */ o(U, { ...l, children: /* @__PURE__ */ o(V, { size: "xs" }) }) }) || e === "information-tooltip" && p && /* @__PURE__ */ o(f, { className: n(["Information-wrapper"]), children: /* @__PURE__ */ o(O, { ...p, children: /* @__PURE__ */ o(V, { size: "xs" }) }) }) || e === "text" && /* @__PURE__ */ o(
  K,
  {
    className: n([
      "Text-wrapper",
      {
        "Text-wrapper--left": c === "left",
        "Text-wrapper--center": c === "center",
        "Text-wrapper--right": c === "right"
      }
    ]),
    children: u
  }
), Q = i.div`
  &.MarketingComparisonTableMobileView-container {
    ${({
  theme: {
    components: { marketingComparisonTable: e }
  }
}) => a(
  e.MarketingComparisonTableMobileViewContainer
)};
  }
`, X = i.span`
  &.MarketingComparisonTableMobileView-header {
    ${({
  theme: {
    components: { marketingComparisonTable: e }
  }
}) => a(e.MarketingComparisonTableMobileViewHeader)};
  }
`, Y = i.span`
  &.MarketingComparisonTableMobileView-description {
    ${({
  theme: {
    components: { marketingComparisonTable: e }
  }
}) => a(
  e.MarketingComparisonTableMobileViewDescription
)};
  }
`, y = i.div`
  &.MarketingComparisonTableMobileViewHeader-wrapper {
    ${({
  theme: {
    components: { marketingComparisonTable: e }
  }
}) => a(
  e.MarketingComparisonTableMobileViewHeaderWrapper
)};
  }
`, A = i.div`
  &.MarketingComparisonTableValueWrapperMobileView-wrapper {
    ${({
  theme: {
    components: { marketingComparisonTable: e }
  }
}) => a(
  e.MarketingComparisonTableValueWrapperMobileViewWrapper
)};
  }
`, ee = i.span`
  &.MarketingComparisonTableRowHeaderMobileView {
    ${({
  theme: {
    components: { marketingComparisonTable: e }
  }
}) => a(
  e.MarketingComparisonTableRowHeaderMobileView
)};
  }
`, oe = i.div`
  &.MarketingComparisonTableMobileViewContent-wrapper {
    ${({
  theme: {
    components: { marketingComparisonTable: e }
  }
}) => a(
  e.MarketingComparisonTableMobileViewContentWrapper
)};
  }
`, re = i.div`
  &.MarketingComparisonTableMobileViewButton-wrapper {
    ${({
  theme: {
    components: { marketingComparisonTable: e }
  }
}) => a(
  e.MarketingComparisonTableMobileViewButtonWrapper
)};
  }
`, be = ({
  headerValues: e,
  rowValues: p,
  isColumnButtonEnabled: l
}) => {
  const [u, c] = s([]), [b, m] = s(""), [v, w] = s("small"), [x, S] = s([]), [W, H] = s(!1), [B, N] = s(""), [P, $] = s(""), [h, I] = s(), g = (r) => {
    const t = e.findIndex(
      (C) => C.id === r
    ), d = e[t], T = p.map((C) => C.cellData[t]);
    S(T);
    const {
      isColumnButtonEnabled: z = !1,
      buttonText: R = "",
      ...E
    } = e[t]?.columnButton || {};
    $(E || void 0), H(z), N(R), I(d);
  };
  F(() => {
    const r = e.map((d, T) => ({
      value: d.id,
      label: d.textValue || ""
    })), t = r.slice(1, r.length);
    c(t), m(t[0]?.label), w(e[1]?.textSize || "small"), g(e[1]?.id || "");
  }, [e]);
  const _ = (r) => {
    const t = e.find(
      (d) => d.id === r.value
    );
    w(t?.textSize || "small"), m(r.label), g(r.value);
  };
  return /* @__PURE__ */ M(
    Q,
    {
      className: n(["MarketingComparisonTableMobileView-container"]),
      children: [
        /* @__PURE__ */ o(
          D,
          {
            placeholder: b,
            options: u,
            selected: b,
            onOptionSelect: _
          }
        ),
        /* @__PURE__ */ M(
          y,
          {
            className: n([
              "MarketingComparisonTableMobileViewHeader-wrapper"
            ]),
            children: [
              h?.leadingComponents,
              /* @__PURE__ */ o(
                X,
                {
                  className: n([
                    "MarketingComparisonTableMobileView-header",
                    `MarketingComparisonTableMobileView-header--${v}`
                  ]),
                  children: b || ""
                }
              ),
              /* @__PURE__ */ o(
                Y,
                {
                  className: n([
                    "MarketingComparisonTableMobileView-description"
                  ]),
                  children: h?.description
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ o(
          oe,
          {
            className: n([
              "MarketingComparisonTableMobileViewContent-wrapper"
            ]),
            children: x.map((r, t) => /* @__PURE__ */ M(
              A,
              {
                className: n([
                  "MarketingComparisonTableValueWrapperMobileView-wrapper"
                ]),
                children: [
                  /* @__PURE__ */ o(
                    ee,
                    {
                      className: n([
                        "MarketingComparisonTableRowHeaderMobileView"
                      ]),
                      children: p[t].cellData[0]?.valueProp?.textValue
                    }
                  ),
                  /* @__PURE__ */ o(
                    L,
                    {
                      type: r.valueProp.type,
                      textValue: r.valueProp.textValue,
                      informationPopuptipProp: r.valueProp.informationPopuptipProp,
                      informationTooltipProp: r.valueProp.informationTooltipProp
                    }
                  )
                ]
              }
            ))
          }
        ),
        l && /* @__PURE__ */ o(
          re,
          {
            className: n([
              "MarketingComparisonTableMobileViewButton-wrapper"
            ]),
            children: W && /* @__PURE__ */ o(Z, { ...P, children: B })
          }
        )
      ]
    }
  );
};
export {
  L as M,
  be as a
};
